import { render, staticRenderFns } from "./ContentView.vue?vue&type=template&id=317781b4&scoped=true&"
import script from "./ContentView.vue?vue&type=script&lang=js&"
export * from "./ContentView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "317781b4",
  null
  
)

export default component.exports